var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1016 1.15539V0H5.89844V1.15539H2.1875V20H17.8125V1.15539H14.1016ZM7.07031 1.17188H12.9297V2.32727H7.07031V1.17188ZM16.6406 18.8281H3.35938V2.32727H5.89844V3.49914H14.1016V2.32727H16.6406V18.8281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.04688 4.86719H4.53125V8.38281H8.04688V4.86719ZM6.875 7.21094H5.70312V6.03906H6.875V7.21094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.99512 6.03906H15.4688V7.21094H9.99512V6.03906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.04688 9.71094H4.53125V13.2266H8.04688V9.71094ZM6.875 12.0547H5.70312V10.8828H6.875V12.0547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.99512 10.8828H15.4688V12.0547H9.99512V10.8828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.99512 15.6484H15.4688V16.8203H9.99512V15.6484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M5.8203 16.2243L5.06272 15.4668L4.23413 16.2954L5.8203 17.8816L8.38304 15.3189L7.55444 14.4902L5.8203 16.2243Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckList);
export default __webpack_public_path__ + "static/media/check_list.f138c7ee278320b86f5e9bdc56b39a2f.svg";
export { ForwardRef as ReactComponent };